import { jsx } from 'react/jsx-runtime';
import { MultipleAnswer } from '@promo-platform/multiple-answer';
import { SingleAnswer } from '@promo-platform/single-answer';

const multiChoiceQuestion = 'MultiChoice';
const QuizAnswers = ({ alias, id, label, description, options, questionType, }) => (jsx("section", Object.assign({ className: "promo-quiz-answers" }, { children: questionType === multiChoiceQuestion ? (jsx(MultipleAnswer, Object.assign({}, { alias, id, label, description, options }))) : (jsx(SingleAnswer, Object.assign({}, { alias, id, label, description, options }))) })));

export { QuizAnswers };
